var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _g, _g2, _g3, _g4, _path67, _g5, _g6, _path68, _path69, _path70, _g7, _path71, _g8, _g9, _g0, _g1, _g10, _g11, _path72;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlower3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 248.76 519.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M370.02,507.56c12.8-10.94,25.55-23.13,38-42,36.27-53.56,42.55-121.85,69.56-222.67,13.2-49.26,28.08-69.16,50.67-138.67,20.67-63.61,48.67-115.89,55.78-230.28",
    fill: "none",
    stroke: "#7db5a9",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M451.91,447.22c-15.78,4.22-32.67,14-46.89,23.78",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M394.8,426.78c5.56,12.89,8.22,32.67,2,53.11",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M477.91,374.33c-13.78,6.44-31.78,19.11-40.89,32.89",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M496.68,315.11c-14.06,4.89-37.44,25-45.39,39.39",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M515.24,248.22c-15.11,4.44-42.77,30.02-50.89,45.33",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M472.71,154.93c6.22,13.11,12.44,38,13.33,56.44",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M441.38,247.38c7.76,11.69,20.15,44.64,19.56,64.44",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M420.13,330.11c6.89,22.22,20.67,40.22,17.78,70",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M423.57,459.11c30.47,3.78,52.71-7.06,64.89-29.33-26.56-3.63-49.23,6.57-64.89,29.33Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M400.68,456.33c-17.22-15.94-24.89-42.72-16.78-75.39,22.78,26.67,26.11,54.56,16.78,75.39Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M456.46,387.33c30.47,3.78,47.78-15.56,54.67-33.33-26.67.67-43.56,10.67-54.67,33.33Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M559.71,141.38c-14.17.83-46.56,18.56-55.67,32.33",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M576.78,55.09c-14.94,7.73-35.89,25.23-44.74,36.62",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M535.05,150.21c32.83,8.83,52.61-4.72,59.5-22.5-25.83-2.17-48.39-.17-59.5,22.5Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M170.05,236.04c-15.51,7.89-36.37,25-39.76,34.92",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M149.45,249.73c24.93,1.87,45.07-20.23,47.6-34.02-18.96,1.99-42.69,16.12-47.6,34.02Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M-187.71,211.92c19.32-15.86,18.64-45.75,10.95-57.47-12.34,14.53-19.76,41.13-10.95,57.47Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M-169.21,247.31c-11.9,7.87-27.3,23.76-29.14,32.16",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M-184.72,260.37c20.49-.8,34.84-20.68,35.61-32.15-15.26,3.39-33.28,17.11-35.61,32.15Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M197.38,154.71c-15.51,7.89-36.37,25-39.76,34.92",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M176.78,168.39c24.93,1.87,45.07-20.23,47.6-34.02-18.96,1.99-42.69,16.12-47.6,34.02Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M205.14,72.72c-10.25,9.46-22.64,27.19-23.1,35.59",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M192.22,87.75c19.65-3.98,30.39-25.4,29.35-36.59-14.2,5.65-29.44,21.71-29.35,36.59Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M609.19-46.31c-12.66,3.81-34.81,21.26-41.14,32.69",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M591.03-35.8c24.47,6.87,40.37-10.6,43.64-26.31-20.67,2.02-38.16,6.84-43.64,26.31Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M602.98-93.68c-7.61,5.64-21.6,24.39-24.43,33.89",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M592.42-79.74c21.58-7.05,29.1-25.6,26.46-38.05-15.23,8.22-28.52,21.32-26.46,38.05Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M431.68,359.67c-23-17.33-33-51.67-27.67-75.67,30.67,30.33,33.67,56,27.67,75.67Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M510.47,77.91c5.16,16.64,9.49,32.4,7.33,54.7",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M557.28-77.57c6.39,14.63,12.85,34.79,10.29,57.74",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M534.71,7.6c6.39,14.63,12.09,29.62,9.53,52.57",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M516.46,102.39c-17.23-12.98-22.66-44.25-18.67-62.22,22.97,22.72,23.16,47.49,18.67,62.22Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M11.27,512.49c12.8-10.94,35.64-27.17,48.08-46.04,36.27-53.56,47.76-118.56,76.25-218.96,14-49.33,60-118,47.01-198.91",
    fill: "none",
    stroke: "#7db5a9",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M-342.19,512.59c79.1-41.85,121.4-149.58,142.42-232.27,7.44-30.33,12.86-61.2,15.43-92.31.08-.96.92-1.67,1.87-1.59.96.08,1.67.91,1.59,1.87-2.46,31.35-7.78,62.41-15.15,92.95-21.01,84.13-63.5,192.97-143.9,235.81-2.91,1.38-5.26-2.79-2.26-4.46h0Z",
    fill: "#7db5a9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M103.24,448.11c-16.58,3.6-33.31,13.5-46.89,23.78",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6,437.82c2.92,13.43,6.04,26.04,0,45.33",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M129.24,375.22c-13.78,6.44-31.78,19.11-40.89,32.89",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M155.49,310.6c-12.12.62-39.86,29.64-48.44,44",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M-247.87,335.44c6.89,22.22,16.11,23.33,13.22,53.11",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M127.46,187c6.89,22.22,14.03,24.04,11.14,53.82",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M161.8,113.33c6.89,22.22,8.36,24.71,5.47,54.49",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M74.91,460c30.47,3.78,52.71-7.06,64.89-29.33-26.56-3.63-49.23,6.57-64.89,29.33Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M-225.2,430.78c-16.58,3.6-33.31,13.5-46.89,23.78",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M-253.54,442.67c30.47,3.78,52.71-7.06,64.89-29.33-26.56-3.63-49.23,6.57-64.89,29.33Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M-598.96,447.67c-15.96,3.46-32.07,12.99-45.14,22.89",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M-626.23,459.11c29.34,3.64,50.74-6.79,62.46-28.24-25.57-3.5-47.39,6.32-62.46,28.24Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M47.94,465.15c-16.52-24.24-22.51-38.78-12.93-68.81,20.91,27.09,23.04,48.96,12.93,68.81Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M-283.4,420.93c2.92,13.43,6.04,26.04,0,45.33",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M-280.06,448.27c-16.52-24.24-22.51-38.78-12.93-68.81,20.91,27.09,23.04,48.96,12.93,68.81Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M-652.82,444.16c2.23,10.26,4.61,19.89,0,34.64",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M-650.27,465.04c-12.62-18.52-17.2-29.63-9.88-52.57,15.97,20.7,17.6,37.41,9.88,52.57Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M107.8,388.22c30.47,3.78,47.78-15.56,54.67-33.33-26.67.67-43.56,10.67-54.67,33.33Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M-188.99,335.86c-13.29,7.39-30.36,21.29-38.49,35.67",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M-209.47,350.33c30.66,1.64,46.57-18.86,52.2-37.07-26.55,2.53-42.7,13.68-52.2,37.07Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M-615.84,422.29c25.4-17.26,25.65-43.21,19.1-61.11-19.6,18.09-25.7,36.75-19.1,61.11Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M-236.32,365c-23-17.33-33-51.67-27.67-75.67,30.67,30.33,33.67,56,27.67,75.67Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M73.46,363c6.89,22.22,16.11,23.33,13.22,53.11",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M85.02,392.56c-23-17.33-33-51.67-27.67-75.67,30.67,30.33,33.67,56,27.67,75.67Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M97.73,291.04c5.97,12.06,13.12,21.51,14.2,38.78",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4,241.26c5.94,7.86,17.76,29.34,16.43,54.23",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M124.07,135.26c5.94,7.86,12.96,32.26,14.09,56.01",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M107.04,306.86c-14.72-7.79-23.58-26.48-22.74-40.67,20.3,14.51,24.36,28.89,22.74,40.67Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M134.93,207.04c-17.43-6.7-25.04-32.63-21.63-47.86,24.09,15.19,26.07,36.58,21.63,47.86Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M-214.67,261.03c4.39,22.85,11.29,25.45,5.13,54.72",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M-209.45,281.78c-16.58-8.59-21.28-35.2-16.21-49.96,22.27,17.76,21.87,39.24,16.21,49.96Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M166.59,132.42c-14.04-8.37-17.84-33.59-13.43-47.46,18.8,17.12,18.32,37.41,13.43,47.46Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M512.23,251.54",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M533.37,208.9",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.96,235.61l-1.67-25.67c-12.5-16.5-32.83-.17-22.17,13.83l23.83,11.83Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.15,236.1l21.39-14.28c8.04-19.08-16.27-28.52-23.06-12.28l1.67,26.56Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.6,248.78",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.65,235.95l23.08,11.36c20.54-2.6,16.52-28.37-.93-26.11l-22.14,14.75Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.14,235.87l1.7,25.66c12.52,16.48,32.83.12,22.15-13.86l-23.85-11.8Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.63,236.02l-21.46,14.18c-8.13,19.04,16.14,28.59,23.01,12.39l-1.55-26.56Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.96,235.61l-23.01-11.5c-20.55,2.48-16.69,28.27.78,26.12l22.23-14.62Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 533.3,
    y1: 235.72,
    x2: 520.07,
    y2: 237.28,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.37,236.36l-13.01,3.32c-3.58.72-4.22-4.67-.56-4.8,0,0,13.43.21,13.43.21.74,0,.87,1.1.15,1.27h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 534.74,
    y1: 234.39,
    x2: 526.8,
    y2: 224.01,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.23,234.78l-9.35-9.3c-2.47-2.69,1.88-6.03,3.84-2.93,0,0,6.53,11.45,6.53,11.45.38.63-.52,1.31-1.02.78h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 534.63,
    y1: 234.83,
    x2: 529.25,
    y2: 249.13,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.23,235.06l-3.72,14.92c-1.03,3.43-6.01,1.56-4.52-1.7,0,0,7.04-13.67,7.04-13.67.34-.67,1.39-.27,1.2.45h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 535.52,
    y1: 236.17,
    x2: 544.91,
    y2: 248.35,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.02,235.78l10.8,11.1c2.38,2.66-1.85,5.94-3.82,2.95,0,0-7.99-13.27-7.99-13.27-.39-.64.5-1.32,1.01-.78h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 535.63,
    y1: 234.28,
    x2: 542.58,
    y2: 222.9,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.08,233.94l5.44-12.3c1.64-3.26,6.27-.43,4.12,2.52,0,0-8.47,10.45-8.47,10.45-.45.58-1.41,0-1.09-.67h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 537.52,
    y1: 235.17,
    x2: 550.41,
    y2: 235.72,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.54,234.53l12.97-1.22c3.66-.16,3.43,5.3-.21,4.82,0,0-12.81-2.33-12.81-2.33-.73-.12-.68-1.22.06-1.28h0Z",
    fill: "#7db5a9"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M596.98,13.79",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.57,40.5l-1.67-25.67c-12.5-16.5-32.83-.17-22.17,13.83l23.83,11.83Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.76,40.99l21.39-14.28c8.04-19.08-16.27-28.52-23.06-12.28l1.67,26.56Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.21,53.67",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.27,40.84l23.08,11.36c20.54-2.6,16.52-28.37-.93-26.11l-22.14,14.75Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.75,40.76l1.7,25.66c12.52,16.48,32.83.12,22.15-13.86l-23.85-11.8Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.24,40.91l-21.46,14.18c-8.13,19.04,16.14,28.59,23.01,12.39l-1.55-26.56Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.57,40.5l-23.01-11.5c-20.55,2.48-16.69,28.27.78,26.12l22.23-14.62Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 596.91,
    y1: 40.61,
    x2: 583.68,
    y2: 42.17,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.98,41.25l-13.01,3.32c-3.58.72-4.22-4.67-.56-4.8,0,0,13.43.21,13.43.21.74,0,.87,1.1.15,1.27h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 598.35,
    y1: 39.28,
    x2: 590.41,
    y2: 28.9,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.84,39.67l-9.35-9.3c-2.47-2.69,1.88-6.03,3.84-2.93,0,0,6.53,11.45,6.53,11.45.38.63-.52,1.31-1.02.78h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 598.24,
    y1: 39.72,
    x2: 592.86,
    y2: 54.01,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.84,39.95l-3.72,14.92c-1.03,3.43-6.01,1.56-4.52-1.7,0,0,7.04-13.67,7.04-13.67.34-.67,1.39-.27,1.2.45h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 599.13,
    y1: 41.06,
    x2: 608.52,
    y2: 53.24,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.63,40.67l10.8,11.1c2.38,2.66-1.85,5.94-3.82,2.95,0,0-7.99-13.27-7.99-13.27-.39-.64.5-1.32,1.01-.78h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 599.24,
    y1: 39.17,
    x2: 606.19,
    y2: 27.79,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.69,38.83l5.44-12.3c1.64-3.26,6.27-.43,4.12,2.52,0,0-8.47,10.45-8.47,10.45-.45.58-1.41,0-1.09-.67h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 601.13,
    y1: 40.06,
    x2: 614.02,
    y2: 40.61,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.16,39.42l12.97-1.22c3.66-.16,3.43,5.3-.21,4.82,0,0-12.81-2.33-12.81-2.33-.73-.12-.68-1.22.06-1.28h0Z",
    fill: "#7db5a9"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M511.17-44.81",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.53-20.33l-6.24-23.5c-14.61-13.02-30.49,5.85-18.03,16.88l24.27,6.62Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.79-19.91l17.24-17.15c3.97-19.16-20.31-23.48-23.64-7.18l6.4,24.33Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.71-12.8",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.16-20.33l23.48,6.32c18.57-6.17,10.14-29.34-5.64-24.05l-17.84,17.73Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.66-20.31l6.27,23.5c14.63,13,30.48-5.89,18.01-16.91l-24.28-6.59Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.29-19.89l-17.32,17.07c-4.06,19.15,20.2,23.57,23.6,7.29l-6.29-24.36Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.53-20.33l-23.44-6.46c-18.61,6.06-10.32,29.28,5.49,24.09l17.95-17.63Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 516,
    y1: -19.92,
    x2: 504.02,
    y2: -16.07,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.2-19.32l-11.44,5.55c-3.39,1.43-5.07-3.78-1.48-4.6,0,0,12.53-2.17,12.53-2.17.72-.13,1.05.91.39,1.22h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 517.1,
    y1: -21.43,
    x2: 507.84,
    y2: -29.6,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.67-20.95l-10.43-6.84c-2.98-2.18.66-6.31,3.2-3.62,0,0,8.08,9.5,8.08,9.5.49.54-.26,1.37-.85.96h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 517.07,
    y1: -20.99,
    x2: 514.69,
    y2: -6.75,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.71-20.89l-.63,14.53c-.33,3.59-5.62,2.72-4.76-.8,0,0,4.13-13.95,4.13-13.95.21-.72,1.3-.53,1.26.21h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 518.14,
    y1: -19.92,
    x2: 529.08,
    y2: -10.34,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.56-20.4l12.11,8.25c2.89,2.15-.66,6.21-3.18,3.63,0,0-9.77-10.92-9.77-10.92-.51-.54.25-1.39.84-.96h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 517.9,
    y1: -21.69,
    x2: 522.27,
    y2: -33.51,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.3-21.91l2.7-12.44c.96-3.55,6.11-1.65,4.53,1.67,0,0-6.03,11.21-6.03,11.21-.34.65-1.36.27-1.2-.44h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 519.82,
    y1: -21.21,
    x2: 531.87,
    y2: -23.05,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.72-21.84l11.79-3.59c3.59-.89,4.42,4.55.73,4.77,0,0-12.33.09-12.33.09-.73.01-.89-1.06-.19-1.26h0Z",
    fill: "#7db5a9"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M443.53,100.21",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.84,125.64l-8.12-24.41c-16.27-12.79-31.8,8.16-17.94,19l26.05,5.41Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.15,126.07l17.08-19.23c2.94-20.49-22.97-23.46-25.42-6.03l8.35,25.27Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.98,131.88",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.57,125.54l25.2,5.14c19.2-7.73,8.79-31.64-7.52-25.02l-17.68,19.89Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.04,125.59l8.15,24.39c16.29,12.77,31.79-8.21,17.91-19.03l-26.06-5.37Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.63,126.12l-17.17,19.16c-3.04,20.48,22.86,23.57,25.39,6.15l-8.23-25.3Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.84,125.64l-25.17-5.29c-19.25,7.61-8.98,31.58,7.37,25.07l17.8-19.78Z",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 450.26,
    y1: 126.17,
    x2: 437.86,
    y2: 131.03,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.49,126.77l-11.75,6.51c-3.28,1.61-5.26-3.45-1.76-4.5,0,0,13.04-3.2,13.04-3.2.72-.18,1.12.84.47,1.19h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 451.32,
    y1: 124.52,
    x2: 441.01,
    y2: 116.49,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.93,125.02l-11.4-6.62c-3.07-1.99.27-6.3,2.97-3.81,0,0,9.22,9.42,9.22,9.42.53.51-.17,1.39-.79,1.01h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 451.32,
    y1: 124.98,
    x2: 449.74,
    y2: 140.17,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.96,125.04l.18,15.37c-.13,3.58-5.42,3.04-4.8-.5,0,0,3.35-15.01,3.35-15.01.16-.73,1.27-.62,1.27.13h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 452.52,
    y1: 126.04,
    x2: 464.7,
    y2: 135.44,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.91,125.53l13.26,8c2.98,1.99-.27,6.2-2.95,3.82,0,0-11.09-10.81-11.09-10.81-.55-.51.16-1.41.78-1.01h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 452.15,
    y1: 124.19,
    x2: 455.99,
    y2: 111.42,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.54,124l2.14-13.28c.76-3.57,5.96-2.01,4.62,1.39,0,0-5.54,12.25-5.54,12.25-.3.68-1.35.36-1.22-.37h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 454.2,
    y1: 124.57,
    x2: 466.81,
    y2: 121.84,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.07,123.94l12.23-4.46c3.5-1.08,4.66,4.25,1.02,4.72,0,0-12.98.99-12.98.99-.73.06-.96-1.01-.27-1.25h0Z",
    fill: "#7db5a9"
  })))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M569.05,204.38c4.21,1.19,14.98-13.68,13.86-25.79-.12-1.3-1.57-2.1-2.85-2.09-7.35.04-16.44,7.9-22.67,14.88",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M507.3,317.21c3.65,4.28,20.08-2.13,24.3-16.08.37-1.21-.66-2.35-1.75-2.97-7.23-4.16-20.88-.89-28.05,5.22",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 496.68,
    y1: 315.11,
    x2: 515.13,
    y2: 307.06,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.48,314.65c4.27-5.26,11.62-8.82,18.44-8.06.32.05.54.35.5.67-3.64,5.64-11.99,8.8-18.54,8.3-.43-.04-.67-.58-.4-.92h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 495.9,
    y1: 314.98,
    x2: 511.82,
    y2: 294.89,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.51,314.67c.72-8.81,7.2-17.77,15.92-20.1.34-.08.68.13.77.47-.08,8.99-7.53,17.58-15.9,20.25-.4.12-.81-.21-.78-.62h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 496.22,
    y1: 316.31,
    x2: 522.27,
    y2: 318.82,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.26,315.81c7.99-3.51,19.02-2.88,26.06,2.51.26.21.3.59.09.84-7.65,4.22-19.25,2.57-26.25-2.36-.35-.25-.29-.82.1-1h0Z",
    fill: "#7db5a9"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M163.77,310.64c3.65,4.28,20.08-2.13,24.3-16.08.37-1.21-.66-2.35-1.75-2.97-7.23-4.16-20.88-.89-28.05,5.22",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 153.16,
    y1: 308.54,
    x2: 171.6,
    y2: 300.49,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.96,308.08c4.27-5.26,11.62-8.82,18.44-8.06.32.05.54.35.5.67-3.64,5.64-11.99,8.8-18.54,8.3-.43-.04-.67-.58-.4-.92h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 152.38,
    y1: 308.41,
    x2: 168.3,
    y2: 288.32,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.99,308.1c.72-8.81,7.2-17.77,15.92-20.1.34-.08.68.13.77.47-.08,8.99-7.53,17.58-15.9,20.25-.4.12-.81-.21-.78-.62h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 152.69,
    y1: 309.74,
    x2: 178.75,
    y2: 312.26,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.74,309.25c7.99-3.51,19.02-2.88,26.06,2.51.26.21.3.59.09.84-7.65,4.22-19.25,2.57-26.25-2.36-.35-.25-.29-.82.1-1h0Z",
    fill: "#7db5a9"
  })))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M555.77,206.08c1.83-6.66,7.22-13.11,13.86-15.34.31-.09.64.08.73.39-1.04,6.7-7.62,13.3-13.85,15.62-.41.15-.85-.25-.74-.67h0Z",
    fill: "#7db5a9"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M554.88,206.5c-2.87-8.58-.52-19.78,6.54-25.72.27-.22.66-.17.88.1,2.82,6.83,1.24,13.92-1.99,20.16-.31.65-4.55,7.43-5.44,5.46h0Z",
    fill: "#7db5a9"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M556.04,207.28c5.99-6.5,16.56-10.5,25.31-8.48.32.08.51.41.43.72-5.37,7.01-16.91,10.31-25.42,8.7-.42-.08-.6-.63-.32-.95h0Z",
    fill: "#7db5a9"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M412.27,226.93",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.93,196.71c-3.11,9.7-2.96,20,.44,30.89,3.16.53,6.57,1.95,10.22,4.22l1.67-9.78c2.09.96,4.51,2.98,7.11,5.56,1.76-1.18,3-6.12,4.22-11.22-5.83-8.43-13.51-15.17-23.67-19.67Z",
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.27,226.93c11.92,1.55,17.92,6.82,28.89,20.17.08.09,0,.24-.12.22-9.87-1.49-21.96-9.19-28.77-20.4Z",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.16,230.27c.38-7.1,1.56-13.08,4.44-16.67,5.92,9.35,4.73,20.75.02,33.15-.05.13-.24.1-.25-.04-.15-9.92-3.65-18.49-13.11-24.66-1.29,3.14-1.47,6.78-1.11,10.67",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.27,227.6c-2.56-11.01-3.04-22.09-.11-30.89,8.4,2.24,18.36,10.03,24.22,18.83",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M549.71,121.88c-5.3,6.33-25,16.17-32.83,17",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M559.73,120.65c5.04,2.51,17.64-9.84,16.05-24.33-.14-1.25-1.52-1.9-2.78-2.05-8.29-.99-19.55,7.37-23.76,15.81",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 549.15,
    y1: 122.88,
    x2: 562.95,
    y2: 108.24,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.79,122.54c1.86-6.51,7.22-12.67,13.8-14.65.32-.08.64.11.72.42-1.11,6.58-7.61,12.82-13.8,14.91-.41.14-.84-.27-.73-.69h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 548.38,
    y1: 123.07,
    x2: 555.14,
    y2: 98.34,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.9,122.94c-2.79-8.38-.35-19.17,6.75-24.73.28-.21.68-.15.89.13,3.45,8.35-.01,19.08-6.68,24.87-.32.27-.83.13-.96-.26h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 549.19,
    y1: 124.17,
    x2: 574.15,
    y2: 116.26,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.04,123.7c5.93-6.35,16.41-10.12,24.96-7.91.32.09.5.42.41.74-5.38,6.88-16.69,9.91-25.07,8.13-.42-.09-.59-.64-.3-.95h0Z",
    fill: "#7db5a9"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M558.6-88.59c4.37-3.75-2.27-20.51-16.56-24.75-1.24-.37-2.4.68-3.04,1.8-4.23,7.41-.82,21.33,5.46,28.64",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 556.5,
    y1: -77.74,
    x2: 548.18,
    y2: -96.55,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.05-77.54c-5.34-4.38-9-11.83-8.32-18.8.04-.32.34-.55.66-.5,5.7,3.68,9,12.27,8.58,18.9-.03.44-.57.67-.91.4h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 556.38,
    y1: -76.95,
    x2: 535.75,
    y2: -93.11,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.07-76.55c-8.92-.77-18.14-7.37-20.63-16.17-.09-.34.11-.68.45-.77,9.14.12,17.94,7.68,20.8,16.15.13.4-.2.82-.62.79h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 557.73,
    y1: -77.27,
    x2: 560.19,
    y2: -103.9,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.24-77.32c-3.53-8.12-2.92-19.42,2.46-26.63.2-.26.58-.3.84-.1,4.25,7.76,2.61,19.67-2.3,26.83-.25.35-.82.3-1-.09h0Z",
    fill: "#7db5a9"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M127.03,128.5c4.93-2.98,1.17-20.6-12.22-27.16-1.16-.57-2.48.27-3.29,1.27-5.4,6.61-4.35,20.9.63,29.15",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 123.15,
    y1: 138.85,
    x2: 118.07,
    y2: 118.92,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.67,138.97c-4.54-5.2-6.91-13.16-5.09-19.93.1-.31.42-.48.73-.39,5.01,4.58,6.83,13.59,5.32,20.07-.1.43-.68.57-.97.25h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 122.9,
    y1: 139.61,
    x2: 105.24,
    y2: 120.24,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.53,139.95c-8.67-2.24-16.66-10.28-17.66-19.37-.03-.35.23-.65.57-.68,7.2,1.35,12.19,6.49,15.57,12.56.37.61,3.64,7.84,1.52,7.48h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 124.29,
    y1: 139.52,
    x2: 131.13,
    y2: 113.66,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.81,139.39c-2.13-8.6.35-19.64,6.84-25.86.24-.22.62-.2.84.04,2.33,6.9.47,13.98-2.55,20.26-.34.66-4.28,7.64-5.13,5.56h0Z",
    fill: "#7db5a9"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M94.27,234.15c4.37-3.75-2.27-20.51-16.56-24.75-1.24-.37-2.4.68-3.04,1.8-4.23,7.41-.82,21.33,5.46,28.64",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 92.17,
    y1: 245.01,
    x2: 83.85,
    y2: 226.2,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.71,245.21c-5.34-4.38-9-11.83-8.32-18.8.04-.32.34-.55.66-.5,5.7,3.68,9,12.27,8.58,18.9-.03.44-.57.67-.91.4h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 92.04,
    y1: 245.8,
    x2: 71.41,
    y2: 229.64,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.73,246.2c-8.92-.77-18.14-7.37-20.63-16.17-.09-.34.11-.68.45-.77,9.14.12,17.94,7.68,20.8,16.15.13.4-.2.82-.62.79h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 93.4,
    y1: 245.48,
    x2: 95.86,
    y2: 218.84,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9,245.43c-3.53-8.12-2.92-19.42,2.46-26.63.2-.26.58-.3.84-.1,4.25,7.76,2.61,19.67-2.3,26.83-.25.35-.82.3-1-.09h0Z",
    fill: "#7db5a9"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M589.58-134.15c5.51-1.96,5.39-20.28-6.58-29.55-1.04-.8-2.52-.23-3.54.59-6.72,5.47-8.62,19.93-5.35,29.16",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 583.6,
    y1: -124.64,
    x2: 582.63,
    y2: -145.53,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.1-124.61c-3.4-6.13-4.12-14.51-.97-20.89.15-.28.51-.39.79-.24,4,5.6,3.96,14.93,1.18,21.08-.18.4-.78.42-1,.05h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 583.19,
    y1: -123.93,
    x2: 569.6,
    y2: -146.83,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.76-123.67c-8.11-4.07-14.39-13.68-13.59-22.91.04-.34.35-.59.69-.55,8.53,3.5,14.11,13.94,13.76,22.95-.02.42-.49.69-.86.51h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 584.59,
    y1: -123.73,
    x2: 596.71,
    y2: -148.09,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.15-123.96c-.3-8.95,4.45-19.47,12.11-24.36.28-.17.64-.08.81.2,1.13,8.85-4.83,19.61-12.03,24.6-.36.24-.88-.02-.9-.45h0Z",
    fill: "#7db5a9"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M187.6,38.15c5.51-1.96,5.39-20.28-6.58-29.55-1.04-.8-2.52-.23-3.54.59-6.72,5.47-8.62,19.93-5.35,29.16",
    fill: "#f9d4f2",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 181.63,
    y1: 47.67,
    x2: 180.66,
    y2: 26.78,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.13,47.7c-3.4-6.13-4.12-14.51-.97-20.89.15-.28.51-.39.79-.24,4,5.6,3.96,14.93,1.18,21.08-.18.4-.78.42-1,.05h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 181.21,
    y1: 48.38,
    x2: 167.62,
    y2: 25.47,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.78,48.64c-8.11-4.07-14.39-13.68-13.59-22.91.04-.34.35-.59.69-.55,8.53,3.5,14.11,13.94,13.76,22.95-.02.42-.49.69-.86.51h0Z",
    fill: "#7db5a9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 182.62,
    y1: 48.57,
    x2: 194.73,
    y2: 24.22,
    fill: "#f9d4f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.17,48.35c-.3-8.95,4.45-19.47,12.11-24.36.28-.17.64-.08.81.2,1.13,8.85-4.83,19.61-12.03,24.6-.36.24-.88-.02-.9-.45h0Z",
    fill: "#7db5a9"
  })))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M-701.56,511.63c49.56-19.78,83.78-67.78,92.44-111.78",
    fill: "none",
    stroke: "#7db5a9",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower3);
export default __webpack_public_path__ + "static/media/flower3.15d32df60ae71021fb945daf407b5893.svg";
export { ForwardRef as ReactComponent };